@if (blockedDealer(); as dealer) {
  <div
    #panel
    class="dealer-context-block"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="dealer-context-block-title"
    aria-describedby="dealer-context-block-description"
    tabindex="-1"
  >
    <h2 id="dealer-context-block-title">{{ 'dealerContextChanged.title' | translate }}</h2>
    <p id="dealer-context-block-description">
      @if (dealer.cmsDealerNumber) {
        {{ 'dealerContextChanged.description' | translate: { dealer: dealer.cmsDealerNumber } }}
      } @else {
        {{ 'dealerContextChanged.descriptionWithoutDealer' | translate }}
      }
    </p>
    <p>{{ 'dealerContextChanged.hint' | translate }}</p>
    <button type="button" ui-ph-button size="small" (click)="reload()">
      {{ 'dealerContextChanged.reload' | translate }}
    </button>
  </div>
}
